export default __webpack_public_path__ + "static/media/whatsapp.11f9b79a.svg";